import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { FormSignUpComplement, Header, Footer } from "~/components/blocks";
import { Margin, Title, Text, Breadcrumb } from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import { Grid } from "@material-ui/core";
import { scrollTo } from "~/utils/tools";
import isMobile from "~/hooks/isMobile";

import { TitleHolder, Warning } from "./styles";
import ReactSVG from 'react-svg';
import triangleError from "~/assets/img/icon/alert-triangle.svg";

export default function SignupComplement() {
  const mobile = isMobile();
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Complemento de cadastro",
      link: "/cadastro-complementar",
    },
  ];

  useEffect(() => {
    scrollTo(450);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Complemento de cadastro</title>
      </Helmet>
      <Header />
      <HeroBanner />
      <Breadcrumb navBreadcrumb={navBreadcrumb} />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <Grid container justifyContent="center">
          <Margin mt={mobile ? 12 : 9} mb={8}>
            <TitleHolder>
              <Title as="1" levelDesktop="2" level="1">
                <strong>Complemente seu cadastro!</strong>
              </Title>
              <Margin>
                <Warning>
                  <ReactSVG src={triangleError} />
                  <Text level="2">
                    Os dados pessoais que você fornecer voluntariamente serão
                    usados para fazer o seu registro nesse site e na promoção
                    Bebê Johnson's. As informações serão utilizadas somente,
                    se necessário, para o processo de entrega de premiação,
                    conforme descrito no regulamento.
                  </Text>
                </Warning>
              </Margin>
            </TitleHolder>
            <FormSignUpComplement />
          </Margin>
        </Grid>
      </motion.div>
      <Footer />
    </>
  );
}
